import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { StsAdminService } from '../sts-admin.service';

@Component({
    selector: 'app-sts-tier-management',
    templateUrl: './sts-tier-management.component.html',
    styleUrls: ['./sts-tier-management.component.scss'],
    standalone: false
})
export class StsTierManagementComponent implements OnInit, OnDestroy {
  tierData: any = [];
  tierAdminSubscription: Subscription;
  deleteTierSub: Subscription;
  maxSelectionDate = new Date();
  notFocused: boolean = false;
  previousValue: any;
  baseSiteId: string;
  baseSub: Subscription;
  stsAdminSub: Subscription;

  constructor(
    public stsAdminService: StsAdminService,
    private readonly cd: ChangeDetectorRef,
    private readonly datePipe: DatePipe,
    private readonly baseSite: BaseSiteService
  ) {}

  ngOnInit(): void {
    this.baseSub = this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.getTierManage();
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.tierAdminSubscription?.unsubscribe();
    this.stsAdminSub?.unsubscribe();
    this.deleteTierSub?.unsubscribe();
  }
  getTierManage() {
    this.stsAdminService.getTierManagement();
    this.tierAdminSubscription = this.stsAdminService.tierManageData$.subscribe(
      (res) => {
        if (res !== null) {
          this.tierData = res.fluTiers;
          this.tierData.forEach((element) => {
            element.insert = false;
            element.active = false;
            element.previousTier = element.tier;
            element.notFocused = [false, false, false];
          });
          this.cd.detectChanges();
        }
      }
    );
  }
  newRow() {
    this.tierData.push({
      endDate: '',
      salesOrg: '',
      startDate: '',
      tier: '',
      insert: true,
      active: false,
      notFocused: [false, false, false],
    });
  }

  update(data, index) {
    data.active = true;
    data.notFocused = [true, true, true];
    data.startDt = this.datePipe.transform(data.startDate, 'MM/dd/yyyy');
    data.endDt = this.datePipe.transform(data.endDate, 'MM/dd/yyyy');

    if (
      this.previousValue !== undefined &&
      this.previousValue !== index &&
      this.tierData[this.previousValue]
    ) {
      this.tierData[this.previousValue].active = false;
    }
    this.previousValue = index;
    if (
      data.tier === '' ||
      data.tier === null ||
      data.startDate === '' ||
      data.endDate === '' ||
      data.startDate === undefined ||
      data.endDate === undefined ||
      new Date(data.startDate) > new Date(data.endDate) ||
      data.startDt === data.endDt ||
      this.numericCheck(data)
    ) {
      return;
    }

    data.active = false;

    let params = {
      salesOrg: data.salesOrg,
      startDate:
        this.datePipe.transform(data.startDate, 'yyyy-MM-ddTh:mm:ss') + 'Z',
      endDate:
        this.datePipe.transform(data.endDate, 'yyyy-MM-ddTh:mm:ss') + 'Z',
      tier: Number(data.tier),
      previousTier: data.insert ? 0 : data.previousTier,
    };
    this.stsAdminSub = this.stsAdminService
      .updateTier(params)
      .subscribe((res) => {
        if (res !== null) {
          this.getTierManage();
        }
      });
  }
  delete(data, index) {
    if (data.insert) {
      this.tierData.splice(index, 1);
    } else {
      let params = {
        salesOrg: data.salesOrg,
        startDate:
          this.datePipe.transform(data.startDate, 'yyyy-MM-ddTh:mm:ss') + 'Z',
        endDate:
          this.datePipe.transform(data.endDate, 'yyyy-MM-ddTh:mm:ss') + 'Z',
        tier: Number(data.tier),
        previousTier: Number(data.tier),
      };
      this.stsAdminService.deleteTier(params);
      this.deleteTierSub = this.stsAdminService.deleteTierItem$.subscribe(
        (res) => {
          if (res) {
            this.getTierManage();
          }
        }
      );
    }
  }
  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  dateValidation(data, index) {
    if (
      (data.startDate === '' ||
        data.endDate === '' ||
        data.startDate === undefined ||
        data.endDate === undefined ||
        new Date(data.startDate) > new Date(data.endDate)) &&
      data.active &&
      data?.notFocused[index]
    ) {
      return true;
    }
    data.startDt =
      data?.startDate?.toString() !== 'Invalid Date'
        ? this.datePipe.transform(data?.startDate, 'MM/dd/yyyy')
        : '';
    data.endDt =
      data?.endDate?.toString() !== 'Invalid Date'
        ? this.datePipe.transform(data?.endDate, 'MM/dd/yyyy')
        : '';

    if (data.startDt === data.endDt && data.active && data?.notFocused[index]) {
      return true;
    }
    return false;
  }
  focusValidation(data, index) {
    data.notFocused[index] = false;
    if (index === 1 && data?.startDate?.toString() === 'Invalid Date') {
      data.startDate = '';
    } else if (index === 2 && data?.endDate?.toString() === 'Invalid Date') {
      data.endDate = '';
    }
  }
  numericCheck(data) {
    let tier: any[] = this.tierData.filter((el) => el.tier === data.tier);
    if (
      (data.tier !== '' || data.tier !== null) &&
      data.active &&
      data?.notFocused[0] &&
      tier.length > 1
    ) {
      return true;
    }
    return false;
  }
}
